import {
  CreateTableMetricRequest,
  DatasetTablesMetricsControllerApi,
  UpdateTableMetricRequest,
} from './generated/apis/DatasetTablesMetricsControllerApi'
import { DatasetRule, MetricTypes, UpdateMetricResponse } from './generated/models'
import { REQUEST_OPTIONS } from './_configs'

const metricsApiClient = new DatasetTablesMetricsControllerApi()

export type CreateDatasetMetricsParams = {
  name: string
  description: string
  formula: string
  type: MetricTypes
  rules: DatasetRule[]
  synonyms?: Array<string>
}

export const createTableMetric = async (datasetId: string, tableId: string, params: CreateDatasetMetricsParams) => {
  const body: CreateTableMetricRequest = {
    datasetId,
    tableId,
    createMetricRequest: {
      metricName: params.name,
      metricDescription: params.description,
      metricFormula: params.formula,
      metricType: params.type,
      rules: params.rules,
      metricSynonyms: params.synonyms,
    },
  }
  return metricsApiClient.createTableMetric(body, REQUEST_OPTIONS)
}

export type UpdateDatasetMetricParams = {
  version: number
  name?: string
  description?: string
  rules: DatasetRule[]
  formula?: string
  synonyms?: Array<string>
  type?: MetricTypes
}

export const updateTableMetric = async (
  metricId: string,
  datasetId: string,
  tableId: string,
  force: boolean,
  metric: UpdateDatasetMetricParams,
): Promise<UpdateMetricResponse> => {
  const body: UpdateTableMetricRequest = {
    metricId,
    datasetId,
    tableId,
    force,
    updateMetricRequest: {
      metricVersion: metric.version,
      metricName: metric.name,
      metricDescription: metric.description,
      rules: metric.rules,
      metricFormula: metric.formula,
      metricSynonyms: metric.synonyms,
      metricType: metric.type,
    },
  }

  return metricsApiClient.updateTableMetric(body, REQUEST_OPTIONS)
}

type DeleteTableMetricParams = {
  datasetId: string
  tableId: string
  metricId: string
  force: boolean
}

export const deleteTableMetric = async (params: DeleteTableMetricParams) => {
  return metricsApiClient.deleteTableMetric(params, REQUEST_OPTIONS)
}
